import React, { Component } from 'react';
import PropTypes from 'prop-types';
import markdown from '../markdown';
import DateTimeDisplay from './DateTimeDisplay';
import Avatar from './Avatar';

export default class AnnouncementDetails extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    linkLabel: PropTypes.string,
    linkUrl: PropTypes.string,
    timestamp: PropTypes.string.isRequired,
    timezone: PropTypes.string,
    onClose: PropTypes.func,
    css: PropTypes.string,
    messageInHtml: PropTypes.bool,
    isAnnouncement: PropTypes.bool,
    trackLinkClick: PropTypes.func.isRequired,
    author: PropTypes.shape({
      avatar: PropTypes.string,
      name: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
    }).isRequired,
  }

  static defaultProps = {
    linkLabel: null,
    linkUrl: null,
    isAnnouncement: false,
    onClose() {},
    timezone: moment.tz.guess(),
    css: '',
    messageInHtml: true, // If false, HTML will be generated using Markdown (without mentions support)
    id: '',
    trackLinkClick() {},
  }

  render() {
    const htmlMessage = this.props.messageInHtml ? this.props.message : markdown.render(this.props.message);

    return (
      <div className={`Popover-item--expanded ${this.props.css}`} ref={(node) => { this.node = node; }}>
        <div className="u-flex u-items-start u-justify-between u-py-2">
          <div className="u-flex u-items-start">
            <div className="u-w-16 u-flex u-justify-center">
              <Avatar
                className="Popover-item-avatar"
                src={this.props.author.avatar}
                name={this.props.author.name}
                type={this.props.author.type}
              />
            </div>
            <div className="u-flex u-flex-col">
              <div className="Popover-item-author u-text-sm">
                {this.props.author.name}
              </div>
              <div className="Popover-item-title">
                <strong>{this.props.title}</strong>
              </div>
            </div>
          </div>
          <div className="u-flex u-items-center u-mr-4">
            <span className="Popover-item-timestamp u-text-sm u-mr-4">
              <DateTimeDisplay timestamp={this.props.timestamp_json} date_only useTimezone={this.props.timezone} />
            </span>
            <span className="Popover-item-status mr-4" onClick={this.props.onClose()}>
              <i className="Icon Icon-close" />
            </span>
          </div>
        </div>
        <div className="Popover-item-message Readability u-pl-16">
          <div dangerouslySetInnerHTML={{ __html: htmlMessage }} />
          { this.props.linkLabel && this.props.linkUrl && (
            <p className="u-text-center u-p-4 u-mr-4">
              <a
                href={this.props.linkUrl}
                className="Button Button--primary"
                data-announcement={this.props.isAnnouncement}
                data-notification-title={this.props.title}
                data-notification-id={this.props.id}
                onClick={this.props.trackLinkClick}
              >
                { this.props.linkLabel }
              </a>
            </p>
          ) }
        </div>
      </div>
    );
  }
}
